import { graphql } from "relay-runtime"

export const deEditEpisodeOfCareMutation = graphql`
  mutation deEditEpisodeOfCareMutation($input: De_updateEpisodeOfCareInput!) {
    updateEpisodeOfCare: de_updateEpisodeOfCare(input: $input) {
      episodeOfCare: de_EpisodeOfCare {
        id
        ...deEpisodeOfCareFragment
      }
    }
  }
`
